<template>
  <div id="mapa-financeiro">
    <div class="w3-col">
      <div v-cloak class="w3-panel w3-theme w3-card" v-if="processando">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>  
      
      <div  v-else v-cloak>
        <div>
        <hr>
          <div class="card-item w3-container w3-small">
            <div class="col s12">
              <div class="w3-col s12 m3 l4">
                <label>Data emissão: </label>
                <strong>{{entrada.data_emissao}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4" v-if="entrada.data_primeiro_vencimento">
                <label>Primeiro vencimento: </label>
                <strong>{{entrada.data_primeiro_vencimento}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4">
                <label>Total produto: </label>
                <strong>R$ {{entrada.total_produtos}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4">
                <label>Modelo nota: </label>
                <strong>{{entrada.modelo_nota}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4">
                <label>Quantidade de itens: </label>
                <strong>{{buscarQuantidadeItensEntrada(entrada)}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4">
                <label>Cadastro ID: </label>
                <strong>{{entrada.cadastro_id}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4">
                <label>Serie nota: </label>
                <strong>{{ entrada.serie_nota}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4">
                <label>Base ST: </label>
                <strong>{{entrada.base_st}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4" v-if="entrada.base_icms != '0,00'">
                <label>Base icms: </label>
                <strong>{{entrada.base_icms}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4"  v-if="entrada.valor_icms != '0,00'">
                <label>Valor ICMS: </label>
                <strong>R$ {{entrada.valor_icms}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4"   v-if="entrada.valor_st != '0,00'">
                <label>Valor ST: </label>
                <strong>R$ {{entrada.valor_st}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4"  v-if="entrada.total_desconto != '0,00'">
                <label>Total desconto: </label>
                <strong>R$ {{ entrada.total_desconto}}</strong>
              </div>

              <div class="w3-col s12 m3 l4"  v-if="entrada.total_frete != '0,00'">
                <label>Total frete: </label>
                <strong>R$ {{ entrada.total_frete}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4" v-if="entrada.valor_ipi != '0,00'">
                <label>Valor IPI: </label>
                <strong>R$ {{entrada.valor_ipi}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4" v-if="entrada.valor_outras_despesas != '0,00'">
                <label>Valor outras despesas: </label>
                <strong>R$ {{entrada.valor_outras_despesas}}</strong>
              </div>
              
              <div class="w3-col s12 m3 l4" v-if="entrada.valor_servicos != '0,00'">>
                <label>Valor serviços:: </label>
                <strong>R$ {{entrada.valor_servicos}}</strong>
              </div>
              
            </div>
            
            <div class="w3-col m12 s12" style=" overflow:auto; padding: 10px">
              <button
                v-if="consolidar && (status == 'Estoque consolidado')"
                class="btn-liberar w3-button w3-theme w3-hide-small"
                @click.stop="consolidarEntrada()"
                style="width: 270px; margin-top:5px; float:left">
                Consolidar financeiro
              </button>
              
              <button
                v-if="consolidar && (status == 'Estoque consolidado')"
                class="btn-liberar w3-button w3-theme w3-hide-large w3-hide-medium"
                @click.stop="consolidarEntrada()"
                style="width: 270px; margin-top:5px; width: 100% !important">
                Consolidar entrada
              </button>
              
              <button
                class="btn-liberar w3-button w3-theme"
                v-if="(
                  (!mostrar_itens) && 
                  (buscarQuantidadeItensEntrada(entrada) > 0)
                )" 
                @click.stop="mostraritens(true)"
                style="width: 270px; margin-top:5px; float: right">
                <span>itens</span>
                <strong>+</strong>
              </button>
              
              <button
                class="btn-liberar w3-button w3-theme"
                v-if="(
                  (mostrar_itens) && 
                  (buscarQuantidadeItensEntrada(entrada) > 0)
                )" 
                @click.stop="mostraritens(false)"
                style="width: 270px; margin-top:5px; float: right">
                itens
                <strong>-</strong>
              </button>
            </div>
          </div>

          <div class="col s12" v-if="mostrar_itens">
            <div
              v-for="(item, index) in entrada.itens"
              class="card-item w3-container w3-small"
              :key="index">

              <div class="w3-col s12 ">
                <strong style="font-weight: inherit; font-style: italic;">item {{index + 1}}</strong>
                <strong style="color:green; margin-left: calc(100% - 140px);">R$ {{item.preco_total}}</strong>
              </div>
              
              <div class="w3-col s12">
                <strong class="w3-text-theme"><i class="fas fa-box"></i>&nbsp;{{item.produto_id}} - {{item.nome_compra}}</strong>
              </div>

              
              <div class="w3-col s12">
                <label>Código original: </label>
                <strong>{{item.codigo_original}}</strong>
              </div>

              <div class="w3-col s12">
                <label>Marca: </label>
                <strong>{{item.marca}}</strong>
              </div>

              <div class="w3-col s12" v-if="item.perc_desconto != '0,0000'">
                <label>Desconto: </label>
                <strong>{{item.perc_desconto}}%</strong>
              </div>

              <div class="w3-col s12" v-if="item.perc_ipi != '0,0000'">
                <label>Ipi: </label>
                <strong>{{item.perc_ipi}}%</strong>
              </div>

              <div class="w3-col s12" v-if="item.peso != '0'">
                <label>Peso: </label>
                <strong>{{item.peso}}</strong>
              </div>

              <div class="w3-col s12" v-if="item.preco != '0,0000000'">
                <label>Preço: </label>
                <strong>R$ {{item.preco}}</strong>
              </div>

              <div class="w3-col s12" v-if="item.quantidade != '0'">
                <label>Quantidade: </label>
                <strong>{{item.quantidade}}</strong>
              </div>

              <div class="w3-col s12" v-if="item.valor_icms != '0,0000'">
                <label>Valor ICMS: </label>
                <strong>R$ {{item.valor_icms}}</strong>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import toastr from 'toastr'
  import formatarValorMixin from '@/mixins/formatarValorMixin.js'
  import REntradaBuscarEntradaDetalhada from '@/components/Rest/REntrada/REntradaBuscarEntradaDetalhada.js'
 
  export default {
    name: 'ModalEntradasSemEstoqueConsolidado',
    
    props: ['entrada_id', 'consolidar', 'status'],
    
    mixins: [formatarValorMixin],
    
    data() {
      return {
        mostrar_itens: false,
        mostrar_detalhes: false,
        processando: true,
        entrada: {},
        prazos: {}
      }
    },

    async mounted() {
      try {
        let parametros = {
          entrada_id: this.entrada_id
        }

        let retorno = await REntradaBuscarEntradaDetalhada.buscarEntradaDetalhada(this.axios, parametros);
        if (retorno.houve_erro != 'N') {
          throw new Error(retorno.mensagem);
        }

        this.entrada = JSON.parse(JSON.stringify(retorno.dados));
        this.processando = false;
      }
      catch (error) {
        this.processando = false;
        toastr.error(error);
      }
    },

    methods: {
      mostraritens(boolean) {
        this.mostrar_itens = boolean;
      },

      detalhes(boolean) {
        this.mostrar_detalhes = boolean;
      },

      atualizar() {
        this.$parent.buscarEntradas();
      },

      buscarQuantidadeItensEntrada(entrada) {
        if (entrada && entrada.itens && entrada.itens.length > 0) {
          return entrada.itens.length;
        }
        else {
          return 0;
        }
      },

      consolidarEntrada() {
        const self = this;
        swal(
          {
            title: 'Confirmar consolidação de financeiro?',
            className: 'modalLiberarCompra',
            buttons: ['Cancelar', 'Confirmar'],
            showCloseButton: true,
            focusConfirm: false,
          }
        )
        .then(
          async (isConfirm) => {
            if (!isConfirm) {
              return false;
            }

            try {
              let parametros = {
                entrada_id: self.entrada_id
              }

              let retorno = REntradaBuscarEntradaDetalhada.buscarEntradasConsolidacao(this.axios, parametros);
              if (retorno.houve_erro != 'N') {
                throw new Error(retorno.mensagem);
              }

              toastr.success('Entrada ' + self.entrada_id + ' consolidada com sucesso.');
              self.atualizar();
            }
            catch (error) {
              toastr.error(error.message);
              return;
            }
          }
        );
      },
    },
  }
</script>

<style scoped>
  .dados_mapa {
    margin-top: 20px;
  }
  
  .card-item {
    background-color: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  .texto-responsivo {
    word-break: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    hyphens: auto;
  }

  .w3-modal-content {
    margin: 0 !important;
    transform: translateX(50%);
  }

  .row-mapa-financeiro{
    padding: 0;
  }

  .divTabelaBloqueios {
    width: 100%;
    float: left;
  }

  .chip-vencimento {
    border-radius: 25px;
    cursor: pointer;
    font-size: .9em;
    padding: 10px 15px;
    text-decoration: underline;
  }

  .card-portador {
    border-left: 3px solid #9c1d1c;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #636363 ;
    padding: 5px 10px;
  }

  .card-portador .w3-text-theme {
    text-transform: uppercase;
  }

  @media(max-width: 992px) {
    .dados_mapa.w3-row-padding {
      padding: 0 !important;
    }
    
    .box-contas {
      margin-bottom: 20px;
    }

    .box-contas:last-child {
      margin-bottom: 0;
    }
  }

  @media(max-width: 500px) {
    .card-pedido-bloqueado .w3-row-padding {
      padding: 0;
    }
  }

  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363 !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
  }

  .btn-liberar {
    width: auto !important;
  }

  .w3-right {
    float: none !important;
    padding-left: 10px;
  }

  .itens-mobile-info {
    float: right;
  }

  .td-itens {
    white-space: nowrap;
    text-align: center;
  }

  .card-informacoes {
    background: white !important
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/ModalEntradasSemEstoqueConsolidado.vue